<template>
  <div class="subfleet">
    <div class="fleet-items">
      <span class="section-label" v-text="$t('components.fleet.debris')"></span>
      <fleet-item-list
        :items="debris"
        :drag-bus="dragBus"
        :simulation-bus="simulationBus"
        :item-type-selection-bus="itemTypeSelectionBus"
        :items-draggable="false"
        :allow-add-items="debris.length === 0"
        :allow-edit-amounts="false"
        :item-group="'resource-' + uid"
        @change="onItemListChanged"
        @itempictureclick="onResourcePictureClick"
        @additem="addResources"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Fleet from "@/store/model/fleet";
import Vue from "vue";
import FleetItemList from "@/components/fleet/FleetItemList";
import { FleetImporter } from "@/services/fleet-importer";

export default {
  name: "DebrisField",
  components: {
    FleetItemList
  },
  props: {
    fleet: {
      type: Fleet,
      default: null
    },
    dragBus: {
      type: Vue,
      required: true
    },
    simulationBus: {
      type: Vue,
      default: null
    },
    itemTypeSelectionBus: {
      type: Vue,
      default: null
    }
  },
  data: () => {
    return {
      uid: null,
      debris: [],
      showImportArea: false,
      itemTypeSelectedCallback: null
    };
  },
  created() {
    this.uid = this.$uuid.v4();
    this.onFleetChanged();
  },
  computed: {
    ...mapGetters("data", ["resourceTypes"])
  },
  watch: {
    fleet() {
      this.onFleetChanged();
    },
    allowRemove() {
      setTimeout(() => {
        this.recalculateNameWidth();
      }, 1);
    }
  },
  methods: {
    ...mapActions("debris", ["markFleetChanged"]),
    onFleetChanged() {
      this.debris = this.fleet.debris;
    },
    onItemListChanged() {
      this.markFleetChanged();
    },
    onImport(event) {
      if (event == null) {
        alert(this.$t("components.fleet.import_failed"));
        return;
      }
      FleetImporter.apply(this.fleet, event, this.role);
      this.$emit("import", event);
      this.markFleetChanged();
    },
    addResources() {
      FleetImporter.addDebrisResourceTypes(this.resources);
    },
    onResourcePictureClick() {
      /*
      this.openItemTypeSelection(this.researchTypes, entry).then(typeId => {
        if (typeId === null) {
          const index = this.research.indexOf(entry.item);
          this.research.splice(index, 1);
        } else {
          entry.typeId = typeId;
          this.markFleetChanged();
        }
      });
      */
    }
  }
};
</script>

<style scoped>
.subfleet:before,
.subfleet > .header:before,
.subfleet > .header:after {
  box-sizing: border-box;
  border-top: var(--border-reg);
}

.subfleet {
  position: relative;
  padding: 1em 0;
}

.subfleet:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top-color: transparent;
  pointer-events: none;
}

.subfleet > .header {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.subfleet > .header:before,
.subfleet > .header:after {
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  height: 1px;
  pointer-events: none;
}

.subfleet > .header:before {
  content: "";
  width: 1em;
  border-top-right-radius: 0;
}

.subfleet > .header:after {
  content: "";
  flex: 1;
  border-top-left-radius: 0;
}
.subfleet > .header > textarea,
.subfleet .remove-subfleet {
  position: relative;
  top: -0.72em;
  line-height: 1em;
  font-size: 1rem;
  height: 1.4em;
}
.subfleet > .header > textarea {
  margin-left: 0.5em;
  margin-right: -0.5em;
  background: transparent;
  border: none;
  font-size: 1em;
  padding: 0.2em 0;
  overflow: hidden;
  resize: none;
}

.subfleet .remove-subfleet {
  display: inline-block;
  width: 1em;
  left: -0.5em;
}

.section-label {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1em;
  width: 100%;
  margin-top: 0.5em;
  margin-bottom: 1em;
}
</style>
